import { BaseRouteService } from "core/services";

class FacilityOrderTemplateMissingDocumentRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-template-missing-documents");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityOrderTemplateId}`, filter);
	}	

	update(resource) {
        return super.update(this.base + '/{id}', resource);
    }	
}

export default FacilityOrderTemplateMissingDocumentRouteService;
